function CycleData({ ipData }) {
  if (!ipData || (!ipData.peakPredicted && !ipData.peakTest)) return null;

  return (
    <div className="mb-4">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary">
        Cycle Data
      </p>
      <div className="space-y-1">
        {ipData.peakPredicted && (
          <div className="rounded-xl bg-primary/10 px-3 py-2 text-sm">Predicted ovulation</div>
        )}
        {ipData.peakTest && (
          <div className="rounded-xl bg-purple-500/20 px-3 py-2 text-sm font-medium">Peak test detected</div>
        )}
      </div>
    </div>
  );
}

export default CycleData;
